module.exports = __webpack_public_path__ + "static/media/value_prop_img_4.31674e10.jpg";


//////////////////
// WEBPACK FOOTER
// ./packages/smart-home-support/assets/resources/SHS-SPRINT/value_prop_img_4.jpg
// module id = 2667
// module chunks = 0